
import Vue from "vue";
import debounce from "lodash.debounce";
import Typography from "@/components/Typography.vue";
import LoadingCircle from "@/components/LoadingCircle.vue";
import { LOYALTY } from "@/store/loyalty";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";

export default Vue.extend({
  components: {
    Typography,
    LoadingCircle
  },
  props: {
    value: {
      type: [Object, String],
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchValue: ""
    };
  },
  computed: {
    hasAccountOffer() {
      return this.accountOffer && this.accountOffer.accountNumber != null;
    },
    hasAccountOfferId() {
      return this.accountOfferId != null;
    },
    isLoading() {
      return !this.hasAccountOfferId && this.customerSearchInProgress;
    },
    search: {
      get() {
        return this.value;
      },
      set(newVal: string) {
        // Update text input value
        this.$emit("text-input", newVal);
        if (newVal) {
          this.debouncedOnSearch(newVal);
        }
      }
    },
    ...mapState({
      accountOffer: (state: IRootState) => state.loyalty.accountOffer,
      customerSearchInProgress: (state: IRootState) =>
        state.loyalty.customerSearchInProgress,
      customerSearchList: (state: IRootState) =>
        state.loyalty.customerSearchList.map(c => {
          (c as any).computedTitle = `${c.customerName} - ${c.accountNumber}`;
          return c;
        })
    }),
    accountOfferId() {
      const id = this.$route.params.id;

      return id ? Number(id) : null;
    }
  },
  created() {
    this.debouncedOnSearch = debounce(this.onSearch, 500);
  },
  methods: {
    onCustomerSearch(searchTerm: string) {
      this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.SEARCH_CUSTOMER_LOOKUP),
        searchTerm
      );
    },
    onInput(value: string) {
      // prevent emitting if an actual customer
      // wasn't selected from the drop down list
      if (value && typeof value !== "string") {
        this.$store.commit(
          LOYALTY.NS(LOYALTY.MUTATIONS.SET_ACCOUNT_OFFER_CUSTOMER),
          value
        );

        // Then update the object input
        this.$emit("input", value);
      }
    },
    onSearch(value: string) {
      (this as any).onCustomerSearch(value);
      this.$emit("search", value);
    },
    onManualInputClick() {
      this.$emit("manual");
    },
    onBlur() {
      this.$emit("blur");
    }
  }
});
